import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useRecoilValue } from 'recoil';
import { DossierIdSelector } from '../../app/recoil/Selector';
import { API_URL } from '../../constants'
import { Timeline, TimelineItem } from 'vertical-timeline-component-for-react';
import { Badge, Button, CircularProgress } from '@material-ui/core'
import Moment from 'react-moment'

import landing_bd from '../../assets/landing-background.png'
import RoadMap from "../Footer/RoadMap";
export default function MainFrame() {


    const [dossier, setDossier] = useState(undefined)


    const [empty, setEmpty] = useState(false)
    // recoil
    const dossier_Id = useRecoilValue(DossierIdSelector)


    useEffect(() => {
        axios.get(`${API_URL}/collections/${dossier_Id}`).
            then(res => {
                setDossier(res.data)
            })
            .catch()
    }, [dossier_Id])

    const docsThread = () => {

        if (dossier !== undefined) {
            const docsCard = dossier.dossier.docs.map(doc => (
                <TimelineItem
                    key={`${doc.name}`}

                    bodyContainerStyle={{
                        background: 'rgb(255 255 255)',
                        padding: '20px',
                        borderRadius: '8px',

                    }}
                    style={{ color: '#0072b4', backgroundColor: '#e86971' }}
                >
                    <h3 id={"time_h3"} style={{ color: 'black' }}>{doc.name}</h3>
                    <h4 id={"time_h4"} style={{ color: 'black' }}>
                        <Moment date={doc.CreatedAt} format="DD/MM/YYYY" />
                    </h4>
                    <p style={{ padding: "5px 2px" }} >
                        {doc.description}
                    </p>
                    <a href={doc.doc_url} target={"_blank"}>
                        <Button style={{ color: '#1572B4', fontWeight: 'bold', borderColor: '#1572B4', borderRadius: '24px' }} variant={'outlined'} >
                            Aperçu
                        </Button>

                    </a>
                </TimelineItem>
            ))
            return (
                <>
                    {docsCard}
                </>
            )
        } else {
            return (
                <div className="is_Loading">
                    <CircularProgress />
                </div>
            )
        }
    }


    return (
        <div className="main_frame" style={{ backgroundImage: `url(${landing_bd})` }} >

            <div className="main_frame_container">
                <div className="heading_main">informations du dossier</div>
                <Badge badgeContent={dossier !== undefined && dossier.dossier !== undefined ? dossier.dossier.docs.length : '0'} >

                    <div className="folder_card">
                        {
                            dossier !== undefined && dossier.dossier !== undefined ? <div>
                                <h1>
                                    {dossier.dossier.name}
                                    <span>
                                        <Moment format="DD/MM/YYYY" date={dossier.dossier.createdAt} />
                                    </span>

                                </h1>


                                <p>
                                    {dossier.dossier.description}
                                </p>
                            </div> : <div className="is_Loading">
                                    <CircularProgress color='secondary' />
                                </div>
                        }

                    </div>
                </Badge>


                <div className="heading_main">Les Pièces du dossier</div>
                <Timeline lineColor={'#ddd'}>
                    {docsThread()}
                </Timeline>
            </div>


        </div>
    )
}
